<div class="app-container" #websiteContainer>
  @if (!isMobile) {
    <app-left-side-navigation [attr.aria-hidden]="isMobile ? 'true' : null"></app-left-side-navigation>
  }
  @if (!isMobile) {
    <app-main-content [attr.aria-hidden]="isMobile ? 'true' : null"></app-main-content>
  }

  @if (isMobile) {
    <div class="mobile-container" [attr.aria-hidden]="!isMobile ? 'true' : null">
      <app-top-navigation></app-top-navigation>
      <div class="content-area">
        <app-mobile-main-content></app-mobile-main-content>
      </div>
      <app-bottom-navigation></app-bottom-navigation>
    </div>
  }
</div>
